import React, { useEffect, useState, useContext } from "react";
import { Link as RouterLink } from "react-router-dom";
import { useMutation } from "react-query";
import { AuthContext } from "../../contexts/AuthContext";
import { loginWithMagicToken } from "../../services/auth.service";
import Button from "../../components/button";
import { ButtonSize, ButtonVariant } from "../../components/button/types";
import { useTranslation } from "react-i18next";

const MagicLinkLoginPage: React.FC = () => {
  const [error, setError] = useState<string | null>(null);
  const { t } = useTranslation("authentication");

  const [message, setMessage] = useState<string>(`${t("verifyin-magic-linc")}`);
  const { setUser } = useContext(AuthContext);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const token = searchParams.get("token");

    if (token) {
      processMagicLink(token);
    } else {
      setError(`${t("magic-linc-not-found")}`);
      setMessage("");
    }
  }, [window.location.search]);

  const { mutate: processMagicLink, isLoading } = useMutation(
    loginWithMagicToken,
    {
      onSuccess: (data: any) => {
        const { user, token } = data.data;
        localStorage.setItem("accessToken", token);
        setUser(user);
        window.location.href = "/";
      },
      onError: (err: any) => {
        setError(`${t("magic-linc-invalid-expired")}`);
        setMessage("");
      },
    }
  );

  return (
    <div className="w-full p-2">
      <div>
        <h2 className="mt-6 text-center text-2xl sm:text-3xl font-extrabold text-gray-900">
          {t("magic-linc")}
        </h2>
      </div>
      <div className="mt-12 ">
        {message && <p className="mt-2">{message}</p>}
        {error && <p className="mt-2 text-red-600 ">{error}</p>}
        {error && (
          <div className="mt-2">
            <Button
              type="button"
              className="mt-6 w-full bg-white"
              variant={ButtonVariant.SECONDARY}
              size={ButtonSize.MEDIUM}
              onClick={() => {
                window.location.href = "/";
              }}
            >
              {t("back-to-login")}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default MagicLinkLoginPage;
